export const CardVariants = {
    STANDARD: 'standard',
    WITH_IMAGE: 'with-image',
    WITH_INLINE_IMAGE: 'with-inline-image',
    TESTIMONIAL: 'testimonial',
};

export default CardVariants;
